import { Label, Spinner, SpinnerSize } from 'office-ui-fabric-react';
import * as React from 'react';

type Props = {
    label: string | JSX.Element;
    className?: string;
    editor: JSX.Element;
    viewer: JSX.Element;
    isLinked: boolean;
    isLoading: boolean;
    errorMessage?: string | null;
};

export const ConnectionField = (props: Props) => {
    const { className, isLinked, label, viewer, editor, isLoading, errorMessage } = props;
    return <>
        <Label className={className} style={{ textTransform: 'capitalize', paddingTop: '5px', paddingBottom: '5px' }}>
            {label}
        </Label>
        {isLinked ? viewer : editor}
        {isLoading && <Spinner size={SpinnerSize.small} className='field-spinner' />}
        {!isLoading && !!errorMessage && <div className="error-message">{errorMessage}</div>}
    </>
};